import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import RegisterForm from '../Components/RegisterForm/RegisterForm'
import Footer from '../Components/Footer/Footer'

function RegisterPage() {
  return (
    <div>
        <Navbar/>
        <RegisterForm/>
        <Footer/>
    </div>
  )
}

export default RegisterPage